import Vue from 'vue'
import entriesTransformer from '@/transformers/catalog/warehouse/entriesWithoutOC'

/**
 * @author jorge nuñez lópez <>
 *
 * Create a new entry without supply configuration 
 * @param payload New entry object
 * @return {object}
 */

export default (newEntryInfo, warehouseId) => {
  const payload = entriesTransformer.sendWithoutOc(newEntryInfo)
  return Vue.$http.post(`iwarehouse/movement/${warehouseId}/in-without-buy-order/no-iws/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/sendEntryWithoutConfig.js